import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import { Link } from 'react-router'
import { Image, Menu } from 'semantic-ui-react'

import Permissions from 'Components/Permissions'
import { FAMILY_ALBUM_URL } from 'Global/constants'

import * as selectors from './selectors'
import * as styles from './styles'

import logo from 'Global/Assets/jk_logo.png'

const Sidebar = props => {
  const { location } = props

  return (
    <Menu fixed="left" style={styles.sidebar} borderless inverted vertical>
      <Image src={logo} size="small" centered />
      <br />

      {/* <Menu.Item active={location === '/'} as={Link} icon="dashboard" name="Home" to="/" /> */}

      <Permissions
        permissions="modules.search"
        render={() => <Menu.Item active={location === '/search'} as={Link} icon="search" name="Search" to="/search" />}
      />

      <Permissions
        permissions="modules.myOrders"
        render={() => <Menu.Item active={location === '/myOrders'} as={Link} icon="spy" name="My Orders" to="/myOrders" />}
      />

      <Permissions
        permissions="modules.mySearches"
        render={() => <Menu.Item active={location === '/mySearches'} as={Link} icon="save" name="My Searches" to="/mySearches" />}
      />

      <Permissions
        permissions="modules.markedForDesigners"
        render={() => (
          <Menu.Item
            active={location === '/markedForDesigners'}
            as={Link}
            icon="pin"
            name="Marked for Designers"
            to="/markedForDesigners"
          />
        )}
      />

      <Permissions
        permissions="modules.requestedRugs"
        render={() => <Menu.Item active={location === '/requestedRugs'} as={Link} icon="feed" name="Requested Rugs" to="/requestedRugs" />}
      />

      <Permissions
        permissions="modules.designerQueue"
        render={() => <Menu.Item active={location === '/designerQueue'} as={Link} icon="tasks" name="Designer Queue" to="/designerQueue" />}
      />

      <Permissions
        permissions="modules.groups"
        render={() => <Menu.Item active={location === '/groups'} as={Link} icon="address book" name="Groups" to="/groups" />}
      />

      <Permissions
        permissions="modules.users"
        render={() => <Menu.Item active={location === '/users'} as={Link} icon="users" name="Users" to="/users" />}
      />

      <Permissions
        permissions="modules.familyAlbum"
        render={() => (
          <Menu.Item active={location.startsWith('/familyAlbum')} as={Link} icon="camera" name="Family Album" to="/familyAlbum" />
        )}
      />

      <Permissions
        permissions="familyAlbum.setup"
        render={() => <Menu.Item as="a" icon="sliders" name="Family Album Setup" href={`${FAMILY_ALBUM_URL}/setup`} target="_blank" />}
      />

      <Permissions
        permissions="modules.status"
        render={() => <Menu.Item active={location === '/status'} as={Link} icon="eye" name="Status" to="/status" />}
      />

      <Permissions
        permissions="modules.debug"
        render={() => <Menu.Item active={location === '/debug'} as={Link} icon="bug" name="Debug" to="/debug" />}
      />
    </Menu>
  )
}

const mapStateToProps = (state, ownProps) => ({
  location: selectors.location(state),
})

Sidebar.propTypes = {
  location: PropTypes.string.isRequired,
}

export default connect(mapStateToProps)(Sidebar)
